import React from 'react';
import { RiLightbulbLine, RiTrophyLine, RiLeafLine, RiHeartLine, RiMapPin2Line, RiPhoneLine, RiMailLine, RiTimeLine } from 'react-icons/ri';
import '../styles/Aboutus.css';

const Aboutus = () => {
  const milestones = [
    {
      year: '2018',
      title: 'Company Founded',
      description: 'Building Depot Suriname was established with a vision to transform lighting in Suriname.'
    },
    {
      year: '2019',
      title: 'First Showroom',
      description: 'Opened our flagship showroom in Paramaribo, showcasing modern lighting solutions.'
    },
    {
      year: '2021',
      title: '1000+ Happy Customers',
      description: 'Reached milestone of serving over 1000 satisfied customers across Suriname.'
    },
    {
      year: '2023',
      title: 'Online Platform Launch',
      description: 'Launched our e-commerce platform to serve customers nationwide.'
    },
    {
      year: '2025',
      title: 'Market Leader',
      description: 'Became Suriname\'s leading provider of modern lighting and living solutions.'
    }
  ];

  const values = [
    {
      icon: <RiLightbulbLine />,
      title: 'Innovation',
      description: 'We bring the latest lighting technology and design trends to Suriname, ensuring our customers have access to cutting-edge solutions.'
    },
    {
      icon: <RiLeafLine />,
      title: 'Sustainability',
      description: 'Our LED lighting solutions are energy-efficient and environmentally friendly, helping reduce energy costs and carbon footprint.'
    },
    {
      icon: <RiHeartLine />,
      title: 'Customer Focus',
      description: 'Every customer is unique. We provide personalized service and solutions tailored to your specific needs and preferences.'
    },
    {
      icon: <RiTrophyLine />,
      title: 'Quality',
      description: 'We only offer products from trusted manufacturers, ensuring durability and reliability in Suriname\'s tropical climate.'
    }
  ];

  return (
    <div className="aboutus-page">
      <div className="aboutus-container">
        
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <h1>About Building Depot Suriname</h1>
            <p className="hero-subtitle">Lights & Living</p>
            <p className="hero-description">
              Illuminating homes and businesses across Suriname with modern, energy-efficient lighting solutions. 
              We're passionate about creating beautiful, functional spaces that enhance your lifestyle.
            </p>
          </div>
          <div className="hero-image">
            <img 
              src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Modern lighting showroom"
            />
          </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p>
              To transform living and working spaces in Suriname through innovative lighting solutions that combine 
              style, efficiency, and affordability. We believe that great lighting enhances quality of life, 
              reduces energy consumption, and creates beautiful environments for families and businesses.
            </p>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  {value.icon}
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Timeline Section */}
        <section className="timeline-section">
          <h2>Our Journey</h2>
          <div className="timeline">
            {milestones.map((milestone, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-year">
                  {milestone.year}
                </div>
                <div className="timeline-content">
                  <h3>{milestone.title}</h3>
                  <p>{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">5000+</div>
              <div className="stat-label">Happy Customers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Lighting Products</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">7</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Customer Support</div>
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        <section className="aboutus-contact-info-section">
          <h2>Visit Our Showroom</h2>
          <div className="aboutus-contact-grid">
            <div className="aboutus-contact-item">
              <RiMapPin2Line className="aboutus-contact-icon" />
              <div>
                <h3>Address</h3>
                <p>Henck Arronstraat 45<br />Paramaribo, Suriname</p>
              </div>
            </div>
            <div className="aboutus-contact-item">
              <RiPhoneLine className="aboutus-contact-icon" />
              <div>
                <h3>Phone</h3>
                <p>546-450</p>
              </div>
            </div>
            <div className="aboutus-contact-item">
              <RiMailLine className="aboutus-contact-icon" />
              <div>
                <h3>Email</h3>
                <p>info@buildingdepotsr.com</p>
              </div>
            </div>
            <div className="aboutus-contact-item">
              <RiTimeLine className="aboutus-contact-icon" />
              <div>
                <h3>Hours</h3>
                {/* <p>Mon-Fri: 8:00 AM - 6:00 PM<br />Sat: 9:00 AM - 4:00 PM</p> */}
                <p>---</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-content">
            <h2>Ready to Transform Your Space?</h2>
            <p>Discover our complete range of lighting solutions and start creating the perfect ambiance for your home or business.</p>
            <div className="cta-buttons">
              <button className="btn-primary" onClick={() => window.location.href = '/products'}>
                Shop Now
              </button>
              <button className="btn-secondary" onClick={() => window.location.href = '/contact'}>
                Get Consultation
              </button>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Aboutus;